// extracted by mini-css-extract-plugin
export default {"nav_section":"Nav_nav_section__y55hR","container":"Nav_container__iNJ9L","logo":"Nav_logo__sD7-c","navItem":"Nav_navItem__6Fpu5"};